import { CustomerAddress } from "./customer-address";

export class CustomerData
{
    public ID:string = '';

    public Name:string = '';
    public Phone:string = '';
    public ProfileImage:string = '';

    public Removed:boolean = false;

    /// <summary>
    /// Profile Type:
    /// <para>0 - Local</para>
    /// <para>1 - Facebook</para>
    /// </summary>
    public ProfileType:number = 0;

    public Adresses:Array<CustomerAddress> = new Array<CustomerAddress>();

    setData(data:any)
    {
        if (typeof(data.Adresses) !== 'undefined' && data.Adresses !== null) 
        {
            this.Adresses = new Array<CustomerAddress>();

            for (const key in data.Adresses) 
            {
                if (Object.prototype.hasOwnProperty.call(data.Adresses, key)) 
                {
                    const element = data.Adresses[key];
                    
                    let adress = new CustomerAddress();

                    Object.assign(adress, element);

                    this.Adresses.push(adress);
                }
            }
        }
    }
}
